<script lang="ts">
	let {
		title = "How the Referral Program Works",
		description = ""
	}: { title?: string; description?: string } = $props();
</script>

<div class="animate-fade-in-up">
	<p class="text-primary text-lg font-bold">Referral Program</p>
	<h2 class="text-foreground mt-2 text-2xl font-semibold tracking-tight text-pretty sm:text-3xl">
		{title}
	</h2>
	<p class="text-foreground/70 mt-6 text-lg">
		{#if description}
			{description}
		{:else}
			Making extra money in your spare time is easy. Anytime you drive, bike walk or run by a
			distressed property, just send us the picture and address of it here from your phone.
		{/if}
	</p>
</div>
